export const NavItems = [
	{
		title: "Programming",
		path: "/programming",
		cName: "navItem",
	},
	{
		title: "Youtube Channel",
		path: "/youtube-channel",
		cName: "navItem",
	},
	{
		title: "Learning",
		path: "/learning",
		cName: "navItem",
	},
	{
		title: "IDE",
		path: "/ide",
		cName: "navItem",
	},
	{
		title: "Community",
		path: "/community",
		cName: "navItem",
	},
	// {
	//   title: "CMS",
	//   path: "/cms",
	//   cName: "navItem",
	// },
	{
		title: "Hosting",
		path: "/hosting",
		cName: "navItem",
	},
	{
		title: "Job Platform",
		path: "/job",
		cName: "navItem",
	},
	{
		title: "Challenge",
		path: "/challenge",
		cName: "navItem",
	},
	{
		title: "Design",
		path: "/design",
		cName: "navItem",
	},
];
